import { atom } from 'infrastructure/state/jotai.wrapper'
import { getFilesRecursive2, googleUserAtom } from 'infrastructure/googleDrive'
import { LessonStructure } from './types'

export const driveDirectoryAtom = atom('')

export const sourceFilesAtom = atom(async (get) => {
  const guser = get(googleUserAtom)
  const dirId = get(driveDirectoryAtom)

  if (dirId === '') return
  if (!guser.credential?.accessToken) return

  const files = await getFilesRecursive2(guser.credential.accessToken, dirId)
  return files
})

export const customRegexFormatAtom = atom(
  'SCMath_6-8_G{grade}_U{unit}_L{lesson}_{name}',
)

const customRegex = atom(/r/)
export const customRegexAtom = atom(
  (get) => new RegExp(get(customRegex)),
  (get, set, newFormat: RegExp) => {
    set(customRegex, newFormat)
  },
)

export const generatedSimpleTreeAtom = atom({
  data: {},
})

export const generatedMetaStructureAtom = atom({
  grade: -1,
  lessons: [] as LessonStructure[],
})
